import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "/Users/michaelwang/Career/JiaLin_Project/meow-admin-vue/node_modules/core-js/modules/es6.array.iterator.js";
import "/Users/michaelwang/Career/JiaLin_Project/meow-admin-vue/node_modules/core-js/modules/es6.promise.js";
import "/Users/michaelwang/Career/JiaLin_Project/meow-admin-vue/node_modules/core-js/modules/es6.object.assign.js";
import "/Users/michaelwang/Career/JiaLin_Project/meow-admin-vue/node_modules/core-js/modules/es7.promise.finally.js";
import Vue from 'vue';
import Cookies from 'js-cookie';
import 'normalize.css/normalize.css'; // A modern alternative to CSS resets

import Element from 'element-ui';
import "./styles/element-variables.scss";
import '@/styles/index.scss'; // global css

import App from "./App";
import store from "./store";
import router from "./router";
import "./icons"; // icon
import "./permission"; // permission control

import * as filters from "./filters"; // global filters

import permission from '@/directive/permission/index.js'; // 权限判断指令

import Print from '@/utils/print'; // 打印

Vue.use(Print);
Vue.use(Element, {
  size: Cookies.get('size') || 'small' // set element-ui default size
});
Vue.directive('permission', permission);

// register global utility filters.
Object.keys(filters).forEach(function (key) {
  Vue.filter(key, filters[key]);
});
Vue.config.productionTip = false;
new Vue({
  el: '#app',
  router: router,
  store: store,
  render: function render(h) {
    return h(App);
  }
});